import { CircularProgress } from "@clockwise/web-commons/src/components/circular-progress";
import { useRouter } from "found";
import React, { useEffect } from "react";
import { FlowStateProvider } from "../../hooks/useFlowState";
import { useOnboarding } from "../../hooks/useOnboarding/useOnboarding";
import { WebAppOnboardingCompleteRenderer } from "../web-app-onboarding-complete";
import { WebOnboardingRenderer } from "../web-onboarding";

function WebOnboardingComponent() {
  const { match, router } = useRouter();
  const { loading, orgId, shouldRenderOnboarding, shouldRedirectApp } = useOnboarding();

  useEffect(() => {
    if (shouldRenderOnboarding) {
      router.push("/app/onboarding");
    }

    if (shouldRedirectApp) {
      // Redirect to home if onboarding is already complete.
      router.replace("/app");
    }
  }, [router, shouldRenderOnboarding, shouldRedirectApp]);

  if (loading) {
    return <CircularProgress />;
  }

  if (shouldRenderOnboarding) {
    return <WebOnboardingRenderer />;
  }

  if (match.location.pathname === "/app/onboarding" && orgId) {
    return <WebAppOnboardingCompleteRenderer orgRelayId={orgId} />;
  }

  return null;
}

export const WebOnboarding = () => (
  <FlowStateProvider>
    <WebOnboardingComponent />
  </FlowStateProvider>
);
